/* eslint-disable no-new */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { isOpenTenant, tanlent, getTokenByonce } from '@/api'
import { getUrlMap } from '@/ultis'
import '@/plugin/vant'
import 'lib-flexible/flexible.js'
import '@/assets/css/index.scss'
import '@/assets/iconfont/iconfont.css'
import * as filter from '@/filters'
import '@/directive'
import Back from '@/components/back.vue'
import circleBtn from '@/components/circleBtn.vue'
import { divToCavasToimg } from './assets/javascript/ultis.js'
// import '../public/fonts/index.css'
// import vConsole from 'vconsole'
// eslint-disable-next-line new-cap
// new vConsole()
Vue.component('Back', Back)
Vue.component('circle-btn', circleBtn)
Object.keys(filter).forEach(k => Vue.filter(k, filter[k]))
Vue.config.productionTip = false
const getConfigJson = async () => {
  console.log('navigator')

  let appVersion = ''
  const version = window.navigator.appVersion
  if (version.indexOf('DingTalk') !== -1) {
    appVersion = 'dd'
  } else {
    appVersion = 'vx'
  }

  const {
    doorName,
    oss,
    videoCdn,
    homeOpenInfo,
    statReportUrl,
    ysUrl,
    baseUrl,
    wsUrl,
    filterGray,
    smallVideoCdn,
    isVconsole,
    wenxuanVideoCdn,
    wenxuanSmallVideoCdn
  } = await fetchJson()
  if (process.env.NODE_ENV === 'production') {
    // const {host, origin} = location
    // const ws = origin.indexOf('https') !== -1 ? 'wss' : 'ws'
    // Vue.prototype.websocketURL = `${ws}://${host}/sd-taolk`
    Vue.prototype.websocketURL = wsUrl
  } else {
    if (process.env.NODE_ENV === 'ys_dev') {
      Vue.prototype.websocketURL = 'ws://ysclass.net/sd-taolk'
    }
    if (process.env.NODE_ENV === '96_dev') {
      Vue.prototype.websocketURL = 'ws://ysdev.com:10103/sd-taolk'
    }
    if (process.env.NODE_ENV === '200_dev') {
      Vue.prototype.websocketURL = 'ws://192.168.38.200/sd-taolk'
    }
    if (process.env.NODE_ENV === 'sc_jky_dev') {
      Vue.prototype.websocketURL = 'ws://47.108.30.203/sd-taolk/'
    }
  }
  Vue.prototype.appVersion = appVersion
  Vue.prototype.doorName = doorName
  Vue.prototype.oss = oss
  Vue.prototype.videoCdn = videoCdn
  Vue.prototype.smallVideoCdn = smallVideoCdn
  Vue.prototype.wenxuanVideoCdn = wenxuanVideoCdn
  Vue.prototype.wenxuanSmallVideoCdn = wenxuanSmallVideoCdn
  Vue.prototype.filterGray = filterGray
  Vue.prototype.$homeOpenInfo = homeOpenInfo
  Vue.prototype.statReportUrl = statReportUrl
  Vue.prototype.$ysUrl = ysUrl
  Vue.prototype.$baseUrl = baseUrl
  Vue.prototype.$isVconsole = isVconsole
  Vue.prototype.$divToCavasToimg = divToCavasToimg
  const isCdn = params => {
    if (!params) return
    if (params.startsWith('http')) {
      return params
    }
    let result = params + ''
    if (result.indexOf('upload/') !== -1 || result.indexOf('upload2/') !== -1) {
      result = videoCdn + params
    }
    return result
  }
  Vue.prototype.$isCdn = isCdn
  if (Vue.prototype.$isVconsole) {
    new window.VConsole()
  }
  try {
    await preDeel()
    // const {data} = await getUser()
    // if (data) {
    //   store.commit('setUser', data)
    // }
  } catch (error) {
    console.log('error', error.data)
  } finally {
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
}
function fetchJson() {
  return new Promise((resolve, reject) => {
    fetch('./serverConfig.json')
      .then(res => {
        return res.json()
      })
      .then(json => {
        resolve(json)
      })
      .catch(error => {
        reject(error)
      })
  })
}

async function preDeel() {
  const map = getUrlMap()
  if (map.accesstoken) {
    localStorage.clear()
    const params = {
      oncetoken: map.accesstoken
    }
    const result = await getTokenByonce(params)
    if (result && result.data && result.data.accessToken) {
      localStorage.setItem('Authorization', 'Bearer ' + result.data.accessToken)
    }
  }
  if (map.noBack) {
    localStorage.setItem('noBack', map.noBack)
  }
  if (map.from && map.from === 'vx') {
    localStorage.setItem('env', 'vx')
  }

  store.commit('setTenantId', '0')
  const { data } = await isOpenTenant()
  store.commit('setOpenTenant', data)
  if (store.state.openTenant === 1) {
    let host
    if (process.env.NODE_ENV === '96_dev') {
      host = 'ysdev.com'
    }
    if (process.env.NODE_ENV === 'ys_dev') {
      host = 'ysclass.net'
    }
    if (process.env.NODE_ENV === '200_dev') {
      host = '192.168.38.200'
    }
    const params = {
      uniqueName: process.env.NODE_ENV !== 'production' ? host : window.location.hostname
    }
    const { data } = await tanlent(params)
    store.commit('setTenantId', data.id)
  }
}

getConfigJson()
console.log('window', window)
